module.exports = __webpack_public_path__ + "img/YasinArif-PazdaSal.817678fd.jpg";